(() => {
  if (customElements.get('pfs-home-sticky')) return;
  const overlays = 'cart-drawer, #popupIframeContainer, #iframe_close, .pfs_common_popup_wrap, .pfs_warning_popup_wrap, .pfs_confirm_popup_wrap, .pfs_header_faq-modal-wrap, .pfs_personalize_call_popup-wrap, .pfs_personalize_video_upgrade-wrap, modal-dialog, [role="dialog"], [aria-modal="true"], .shopify-pc__banner__dialog, header-drawer details, details.mega-menu, details-modal details, [data_pfs_map_modal_overlay]';
  const visible = element => {
    if (!element?.isConnected || !element.getClientRects().length) return false;
    for (let node = element; node && node !== document.body; node = node.parentElement) {
      const css = getComputedStyle(node);
      if (node.hidden || css.display === 'none' || css.visibility === 'hidden' || css.opacity === '0') return false;
    }
    return true;
  };
  class HomeSticky extends HTMLElement {
    connectedCallback() {
      if (this.cleanup || !window.ResizeObserver) return;
      const source = document.querySelector('.delivered-step-img-btn');
      const target = source?.hash && document.getElementById(source.hash.slice(1));
      const section = this.closest('.shopify-section');
      const guarantee = section?.querySelector('.mg-image');
      const packages = document.querySelector('.pricing-plans');
      const header = document.querySelector('.section-header');
      const announcement = document.querySelector('.announcement-bar-section');
      if (!source || !target || !guarantee || !packages || !header) return;
      const html = document.documentElement;
      const bar = document.createElement('div');
      bar.className = 'pfs-home-sticky-bar';
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', source.textContent.trim());
      bar.setAttribute('aria-hidden', 'true');
      const link = document.createElement('a');
      link.href = source.getAttribute('href');
      link.textContent = source.textContent.trim();
      link.tabIndex = -1;
      bar.append(link);
      const clearance = document.createElement('div');
      clearance.className = 'pfs-home-sticky-clearance';
      clearance.setAttribute('aria-hidden', 'true');
      document.body.append(bar, clearance);
      let frame = 0, stopped = false, maximum = 0;
      const listeners = [];
      const observe = new MutationObserver(schedule);
      const watched = new Set();
      const media = matchMedia('(max-width: 749px)');
      const setStyle = (element, name, value) => {
        if (element.style.getPropertyValue(name) !== value) element.style.setProperty(name, value);
      };
      const show = value => {
        if (bar.dataset.visible !== String(value)) {
          bar.dataset.visible = String(value);
          bar.setAttribute('aria-hidden', String(!value));
          link.tabIndex = value ? 0 : -1;
        }
      };
      function schedule() {
        if (!stopped && !frame) frame = requestAnimationFrame(update);
      }
      function update() {
        frame = 0;
        if (!media.matches) { show(false); return; }
        document.querySelectorAll(overlays).forEach(element => {
          if (watched.has(element)) return;
          watched.add(element);
          for (let node = element; node && node !== document.body; node = node.parentElement) {
            observe.observe(node, { attributes: true, attributeFilter: ['open', 'class', 'style', 'hidden', 'aria-hidden'] });
          }
        });
        let overlay = false;
        for (const element of watched) {
          if (!element.isConnected) { watched.delete(element); continue; }
          if (element.matches('cart-drawer') && !element.classList.contains('active')) continue;
          if (element.matches('details, modal-dialog') && !element.hasAttribute('open')) continue;
          if (visible(element)) { overlay = true; break; }
        }
        const bodyCSS = getComputedStyle(document.body);
        const locked = bodyCSS.position === 'fixed' || bodyCSS.overflowY === 'hidden' || document.body.classList.contains('overflow-hidden');
        const viewport = window.visualViewport;
        const height = viewport?.height || innerHeight;
        const zoomOrKeyboard = viewport && (viewport.scale > 1.05 || viewport.height < innerHeight * 0.75);
        const editable = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
        const announcementHeight = announcement ? announcement.offsetHeight : 0;
        const packagesBottom = packages.getBoundingClientRect().bottom;
        const headerBottom = header.offsetHeight + announcementHeight;
        const progress = Math.min(height * 0.75 - guarantee.getBoundingClientRect().top, headerBottom - packagesBottom);
        const packagesPassed = packagesBottom <= headerBottom;
        const offset = packagesPassed ? Math.min(announcementHeight, Math.max(0, progress)) : 0;
        if (!locked && !overlay && !zoomOrKeyboard) {
          setStyle(html, '--pfs-home-announcement-offset', `${offset}px`);
          setStyle(html, '--pfs-home-nav-top', `${announcementHeight - offset}px`);
        }
        const barHeight = bar.getBoundingClientRect().height;
        const fits = barHeight + header.offsetHeight <= height * 0.30;
        const reveal = packagesPassed && progress >= announcementHeight && fits && !overlay && !locked && !zoomOrKeyboard && !editable;
        if (!reveal && bar.contains(document.activeElement) && !overlay && !locked && !editable) {
          source.focus({ preventScroll: true });
        }
        show(reveal);
        if (reveal && barHeight > maximum) {
          maximum = barHeight;
          setStyle(clearance, '--pfs-home-clearance', `${maximum}px`);
          setStyle(html, '--pfs-home-clearance', `${maximum}px`);
        }
      }
      const listen = (node, event, callback, options) => {
        node?.addEventListener(event, callback, options);
        listeners.push(() => node?.removeEventListener(event, callback, options));
      };
      listen(window, 'scroll', schedule, { passive: true });
      listen(window, 'resize', schedule, { passive: true });
      listen(window, 'pageshow', schedule);
      listen(window.visualViewport, 'resize', schedule, { passive: true });
      listen(window.visualViewport, 'scroll', schedule, { passive: true });
      listen(document, 'focusin', schedule);
      listen(document, 'focusout', schedule);
      listen(document, 'transitionend', schedule, true);
      listen(document, 'shopify:section:load', schedule);
      observe.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'], childList: true });
      const resize = new ResizeObserver(schedule);
      [document.querySelector('main'), guarantee, packages, header, announcement, bar].filter(Boolean).forEach(element => resize.observe(element));
      html.classList.add('pfs-home-sticky-page');
      this.cleanup = () => {
        stopped = true;
        cancelAnimationFrame(frame);
        listeners.forEach(remove => remove());
        observe.disconnect();
        resize.disconnect();
        bar.remove();
        clearance.remove();
        html.classList.remove('pfs-home-sticky-page');
        ['--pfs-home-announcement-offset', '--pfs-home-nav-top', '--pfs-home-clearance'].forEach(name => html.style.removeProperty(name));
        this.cleanup = null;
      };
      schedule();
    }
    disconnectedCallback() { this.cleanup?.(); }
  }
  customElements.define('pfs-home-sticky', HomeSticky);
})();
